import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getHttpInstance } from '@app/services/defaultHttpService';
import { replaceTokensInUrl } from '@app/utils';
import endpoints from '@app/constants/endpoints';

const useGetCustCareTelephonyInfo = () => {
  const [showLoading, setShowLoading] = useState(true);
  const [error, setError] = useState(false);
  const [regionalNumbers, setRegionalNumbers] = useState({});

  const userCountryCode = useSelector(state => state.common.userCountryCode);
  const storeId = useSelector(state => state.common.storeId);
  const http = getHttpInstance();
  const url = replaceTokensInUrl(
    endpoints.TELEPHONYINFO_COUNTRY_CODE_URL,
    storeId,
    userCountryCode || 'US'
  );

  useEffect(() => {
    http
      .get(url)
      .then(response => {
        if (response) {
          const { RequestedCountryInfo, DefaultInfo } =
            response?.data?.custCareTelephonyInfoDetails;

          setRegionalNumbers(
            RequestedCountryInfo
              ? {
                  // Check if numbers exist, and then add
                  ...(RequestedCountryInfo.phoneNumber && {
                    phoneNumber: RequestedCountryInfo.phoneNumber
                  }),
                  ...(RequestedCountryInfo.direct && {
                    direct: RequestedCountryInfo.direct
                  })
                }
              : DefaultInfo
          );
        }
        setShowLoading(false);
      })
      .catch(err => {
        if (err) {
          setError(true);
        }
        setShowLoading(false);
      });
  }, [userCountryCode, storeId]);

  return { regionalNumbers, showLoading, error };
};

export default useGetCustCareTelephonyInfo;
